module.exports = __webpack_public_path__ + "img/cashback.47db3d13.png";